<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="serialNo"
                  label="Serial No"
                  v-model="checkListFrequency.serialNo"
                  type="text"
                  :rules="rules.serialNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="checkListFrequency.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="checkListFrequency.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="checkListFrequency.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="checkListFrequency.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="checkListFrequency.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="checkListFrequency.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="checkListFrequency.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="checkListFrequency.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="checkListFrequency.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
  
<script>
import { checkListFrequencyService } from "../../services/check-list-frequency-service";
import { CheckListFrequency } from "../../models/model";
import { CheckListFrequencyFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";

export default {
  name: "CheckListFrequencyDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Check List Frequency",
        disabled: false,
        to: "check-list-frequencys",
      },
      {
        text: "Check List Frequency Detail",
        disabled: true,
      },
    ],
    checkListFrequency: new CheckListFrequency(),
    oldcheckListFrequency: new CheckListFrequency(),
    rules: new CheckListFrequencyFormRules(),
    updatedDate: "",
    createdDate: "",
    responseError: "",
    statusFlag: true,
  }),
  created() {
    const id = this.$route.params.id;
    if (id != "new") {
      this.getCheckListFrequencyDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.checkListFrequency.status = this.statusFlag
            ? "ACTIVE"
            : "INACTIVE";

          checkListFrequencyService
            .saveCheckListFrequency(this.checkListFrequency)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getCheckListFrequencyDetail(id) {
      checkListFrequencyService
        .getCheckListFrequencyDetail(id)
        .then((res) => {
          this.checkListFrequency = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.checkListFrequency.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.checkListFrequency.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.oldCheckListFrequency = Object.assign({}, res.data);
          this.statusFlag =
            this.checkListFrequency.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.checkListFrequency.id) {
        this.checkListFrequency = new CheckListFrequency();
        this.statusFlag = true;
      } else {
        this.checkListFrequency = Object.assign({}, this.oldCheckListFrequency);
        this.statusFlag =
          this.checkListFrequency.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/check-list-frequencys");
    },
  },
};
</script>
  
  